// extracted by mini-css-extract-plugin
export default {"cover":"Cover_cover__TYWAc","video":"Cover_video__qmHfL"};